import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'new-hire.field-1-name': {
    id: 'new-hire.field-1-name',
    defaultMessage: 'Task',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Task',
  },
  'new-hire.field-2-name': {
    id: 'new-hire.field-2-name',
    defaultMessage: 'Description',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Description',
  },
  'new-hire.field-3-name': {
    id: 'new-hire.field-3-name',
    defaultMessage: 'Status',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Status',
  },
  'new-hire.field-3-select-option-1': {
    id: 'new-hire.field-3-select-option-1',
    defaultMessage: 'Complete',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: Complete',
  },
  'new-hire.field-3-select-option-2': {
    id: 'new-hire.field-3-select-option-2',
    defaultMessage: 'To do',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: To do',
  },
  'new-hire.field-4-name': {
    id: 'new-hire.field-4-name',
    defaultMessage: 'Resources',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Resources',
  },
  'new-hire.field-5-name': {
    id: 'new-hire.field-5-name',
    defaultMessage: 'Time period',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Date Range',
  },
  'new-hire.field-5-select-option-1': {
    id: 'new-hire.field-5-select-option-1',
    defaultMessage: 'Day 1-30',
    description:
      'The option value for option #1 in field #5 for this database template. In this case: Day 1-30',
  },
  'new-hire.field-5-select-option-2': {
    id: 'new-hire.field-5-select-option-2',
    defaultMessage: 'Day 30-60',
    description:
      'The option value for option #2 in field #5 for this database template. In this case: Day 30-60',
  },
  'new-hire.field-5-select-option-3': {
    id: 'new-hire.field-5-select-option-3',
    defaultMessage: 'Day 60-90',
    description:
      'The option value for option #3 in field #5 for this database template. In this case: Day 60-90',
  },
  'new-hire.view-1-name': {
    id: 'new-hire.view-1-name',
    defaultMessage: 'All deliverables',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All deliverables',
  },
  'new-hire.entry-1-cell-1': {
    id: 'new-hire.entry-1-cell-1',
    defaultMessage: 'Introduce yourself to the team',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Introduce yourself to the team',
  },
  'new-hire.entry-1-cell-2': {
    id: 'new-hire.entry-1-cell-2',
    defaultMessage:
      'Now is the perfect opportunity to introduce yourself to your team! Share your interests and hobbies, and take the chance to connect with your fellow employees.',
    description:
      'The text value of cell #2 in row (entry) #1 in this database template. In this case:  Now is the perfect opportunity to introduce yourself to your team! Share your interests and hobbies, and take the chance to connect with your fellow employees.',
  },
  'new-hire.entry-2-cell-1': {
    id: 'new-hire.entry-2-cell-1',
    defaultMessage: 'Explore Slack channels',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  Explore Slack channels',
  },
  'new-hire.entry-2-cell-2': {
    id: 'new-hire.entry-2-cell-2',
    defaultMessage:
      'Browse channels in Slack to explore any public channels that capture your interest.',
    description:
      'The text value of cell #2 in row (entry) #2 in this database template. In this case:  Browse channels in Slack to explore any public channels that capture your interest.',
  },
  'new-hire.entry-3-cell-1': {
    id: 'new-hire.entry-3-cell-1',
    defaultMessage: '30-day check in',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  30-day check in',
  },
  'new-hire.entry-3-cell-2': {
    id: 'new-hire.entry-3-cell-2',
    defaultMessage:
      'Congratulations on reaching your one-month milestone!🎉<br></br><br></br>To reflect on your experiences over the past month, we encourage you to schedule a one-on-one check-in with your manager for feedback.<br></br><br></br>This meeting is not intended to serve as a performance review; rather, it is an opportunity to assess your progress and discuss how your manager can offer guidance to enhance your journey.',
    description:
      'The text value of cell #2 in row (entry) #3 in this database template. In this case:  Congratulations on reaching your one-month milestone!🎉 To reflect on your experiences over the past month, we encourage you to schedule a one-on-one check-in with your manager for feedback. This meeting is not intended to serve as a performance review; rather, it is an opportunity to assess your progress and discuss how your manager can offer guidance to enhance your journey.',
  },
  'new-hire.entry-4-cell-1': {
    id: 'new-hire.entry-4-cell-1',
    defaultMessage: '60-day check in',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template. In this case:  60-day check in',
  },
  'new-hire.entry-4-cell-2': {
    id: 'new-hire.entry-4-cell-2',
    defaultMessage:
      'Congratulations on reaching your two-month milestone! 🎊<br></br><br></br>Take some time for a self-review and connect with your Manager for valuable feedback.<br></br><br></br>See you again at your 90-day milestone!',
    description:
      'The text value of cell #2 in row (entry) #4 in this database template. In this case:  Congratulations on reaching your two-month milestone! 🎊 Take some time for a self-review and connect with your Manager for valuable feedback. See you again at your 90-day milestone!',
  },
  'new-hire.entry-5-cell-1': {
    id: 'new-hire.entry-5-cell-1',
    defaultMessage: 'Learning and development hub',
    description:
      'The text value of cell #1 in row (entry) #5 in this database template. In this case:  Learning and development hub',
  },
  'new-hire.entry-5-cell-2': {
    id: 'new-hire.entry-5-cell-2',
    defaultMessage:
      'We are committed to supporting your growth in your new role. Be sure to explore our Learning and development hub, which serves as the central resource for all learning and development.',
    description:
      'The text value of cell #2 in row (entry) #5 in this database template. In this case:  We are committed to supporting your growth in your new role. Be sure to explore our Learning and development hub, which serves as the central resource for all learning and development.',
  },
  'new-hire.entry-6-cell-1': {
    id: 'new-hire.entry-6-cell-1',
    defaultMessage: '90-day check in',
    description:
      'The text value of cell #1 in row (entry) #6 in this database template. In this case:  90-day check in',
  },
  'new-hire.entry-6-cell-2': {
    id: 'new-hire.entry-6-cell-2',
    defaultMessage:
      'Congratulations on reaching your three-month milestone! 🚀<br></br><br></br>To effectively evaluate your first three months, dedicate some time to conduct a self-review and engage in your first Performance conversation with your Manager.',
    description:
      'The text value of cell #2 in row (entry) #6 in this database template. In this case:  Congratulations on reaching your three-month milestone! 🚀 To effectively evaluate your first three months, dedicate some time to conduct a self-review and engage in your first Performance conversation with your Manager.',
  },
  'new-hire.entry-7-cell-1': {
    id: 'new-hire.entry-7-cell-1',
    defaultMessage: 'Your to-do list',
    description:
      'The text value of cell #1 in row (entry) #7 in this database template. In this case:  Your to-do list',
  },
  'new-hire.entry-7-cell-2': {
    id: 'new-hire.entry-7-cell-2',
    defaultMessage:
      'Utilize this card to monitor the tasks you’ve assigned to yourself or those discussed with your manager for the upcoming month.',
    description:
      'The text value of cell #2 in row (entry) #7 in this database template. In this case:  Utilize this card to monitor the tasks you’ve assigned to yourself or those discussed with your manager for the upcoming month.',
  },
});
